import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import Seo from "../../../common/helpers/seo";

import routing from "../../routing";

import {
    StyledClosingClassroom,
    StyledSpring,
} from "./styles";
import messages from "./messages";

const ClosingClassroom = () => (
    <StyledSpring withShadow marginTop={50}>
        <Seo title="Musicators" />
        <StyledClosingClassroom>
            <h3>
                <FormattedMessage {...messages.title} />
            </h3>
            <Link className={"link"} to={`/${routing.join}`}>
                <FormattedMessage {...messages.again} />
            </Link>
        </StyledClosingClassroom>
    </StyledSpring>
);

export default ClosingClassroom;
